import { motion } from "framer-motion";

export const Header = () => {
  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 inset-x-0 z-50 bg-white border-b border-[#e4e4e7] shadow-[0_2px_12px_rgba(0,0,0,0.04)]"
    >
      <div className="mx-auto max-w-6xl px-6 h-24 sm:h-28 flex items-center justify-center">
        <img
          src="/kohinoor-logo.webp"
          alt="Hotel Kohinoor logo"
          data-testid="header-logo"
          className="h-16 sm:h-20 lg:h-[5.5rem] w-auto object-contain select-none"
          draggable="false"
        />
      </div>
    </motion.header>
  );
};

export default Header;
